
function addClassWhenVisible() {
  // Get all section tags on the page
  var sections = document.getElementsByTagName('section');
  
  // Create array of section IDs
  var sectionIds = [];
  for (var i = 0; i < sections.length; i++) {
    if (sections[i].id) {
      sectionIds.push(sections[i].id);
    }
  }
  console.dir(sectionIds);
  // Add event listener to window object when page is loaded
  
  
  window.addEventListener('load', function() {
    // Iterate through each section ID in the array
    sectionIds.forEach(function(id) {
      var el = document.getElementById(id);
      // Check if element exists on the page
      if (el) {
        // Add event listener to window object when page is scrolled or resized
        window.addEventListener('scroll', function() {
          if (isElementVisible(el)) {
            // Add class to body tag if element is onscreen
            document.body.classList.add(id + '-on');
			/*if(id == "videoplayer"){
				playVideo();
			} */
          } else {
            // Remove class from body tag if element is offscreen
            document.body.classList.remove(id + '-on');
			/* if(id == "videoplayer"){
				$("#console").html("goodbye");
			}	
			*/			
          }
        });
      }
    });
  });
  
}

function isElementVisible(el) {
  var rect = el.getBoundingClientRect();
  var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
  return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
}

addClassWhenVisible();

// adds loaded class to body tag
window.addEventListener('load', function() {
	document.body.classList.add('loaded');
});




// Get a reference to the MediaElement.js video player with the ID of "videoplayer"

window.addEventListener('load', function() {
//	var videoPlayer = document.getElementById('videoplayer');
});
// Play the video
function playVideo() {
  videoPlayer.play();
}

// Pause the video
function pauseVideo() {
  videoPlayer.pause();
}

// Toggle the video between play and pause
function togglePlayPause() {
  if (videoPlayer.paused) {
    playVideo();
  } else {
    pauseVideo();
  }
}

// Stop the video and reset to the beginning
function stopVideo() {
  videoPlayer.pause();
  videoPlayer.setCurrentTime(0);
}

// Set the volume of the video player (accepts a value between 0 and 1)
function setVolume(volume) {
  videoPlayer.setVolume(volume);
}

// Mute the video player
function mute() {
  videoPlayer.setMuted(true);
}

// Unmute the video player
function unmute() {
  videoPlayer.setMuted(false);
}



window.addEventListener('load', function() {
	
//	$(".type-team-members .wp-block-post-featured-image, .type-team-members .arrow-link").click(function(){
	$(".type-team-members .wp-block-post-featured-image").click(function(){
		$(this).parent( ".type-team-members" ).addClass("show");
	});
	$(".type-team-members .arrow-link").click(function(){
		$(this).parent( ".type-team-members" ).addClass("show");
		event.preventDefault();
	});
	$("li.type-team-members .close").click(function(){
		$("li.type-team-members").removeClass("show");
	});
});


window.addEventListener('load', function() {
	$(".accordion li:first-of-type").addClass("show");
	$(".accordion li").click(function(){
		$(".accordion li").removeClass("show");
		$(this).toggleClass("show");
	});
});